import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/button';
import { getImageForItem } from '../data/categoryImages';
import { Plus } from 'lucide-react';

const ITEM_VARIANTS = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: [0.25, 0.4, 0.55, 1.4] } },
};
const CARD_HOVER = { y: -8, scale: 1.02 };
const CARD_SPRING = { type: 'spring', stiffness: 300, damping: 20 };
const IMAGE_HOVER = { scale: 1.1 };
const IMAGE_TRANSITION = { duration: 0.4 };
const BUTTON_HOVER = { scale: 1.05 };
const BUTTON_TAP = { scale: 0.95 };

const getLocalizedText = (value, language) =>
  typeof value === 'string' ? value : value[language];

export const MenuItemCard = ({ item, category, index, language, onAddToCart, translations: t }) => {
  const name = getLocalizedText(item.name, language);
  const price = getLocalizedText(item.price, language);
  const desc = item.desc ? getLocalizedText(item.desc, language) : null;
  const imageUrl = getImageForItem(category.id, index);

  return (
    <motion.div
      variants={ITEM_VARIANTS}
      whileHover={CARD_HOVER}
      transition={CARD_SPRING}
      className="rounded-2xl border border-border bg-card overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.04)] dark:shadow-none hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)] dark:hover:shadow-[0_20px_40px_rgba(0,0,0,0.3)] transition-shadow duration-300"
      data-testid={`menu-item-${category.id}-${index}`}
    >
      <div className="relative h-48 overflow-hidden bg-muted">
        <motion.img
          src={imageUrl}
          alt={name}
          className="w-full h-full object-cover"
          whileHover={IMAGE_HOVER}
          transition={IMAGE_TRANSITION}
        />
        <div className="absolute top-3 right-3 h-10 w-10 rounded-full flex items-center justify-center backdrop-blur-sm">
          <img src="/mirnas-logo.png" alt="Mirna's Logo" className="h-full w-full object-contain drop-shadow-lg" />
        </div>
      </div>
      <div className="p-6 space-y-4">
        <div>
          <h3 className="text-xl font-bold leading-tight">{name}</h3>
          {desc && <p className="mt-1 text-sm text-muted-foreground">{desc}</p>}
        </div>
        <div className="flex items-center justify-between gap-3">
          <span className="text-lg font-bold text-primary">{price}</span>
        </div>
        <Button
          onClick={() => onAddToCart(item, category.title[language])}
          className="w-full rounded-full font-semibold group"
          data-testid={`add-to-cart-${category.id}-${index}`}
        >
          <motion.div className="flex items-center justify-center gap-2" whileHover={BUTTON_HOVER} whileTap={BUTTON_TAP}>
            <Plus className="h-4 w-4" />
            {t.addToCart}
          </motion.div>
        </Button>
      </div>
    </motion.div>
  );
};
